export default __webpack_public_path__ + "50106fed5c33fb65b9eec4308dc8a813.svg";